import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import Header from './Header';
import Nav from './Nav';
import KPIs from './KPIs';
import QdtComponent from './QdtComponent';
import Footer from './Footer';
import qDocPromise from '../js/qDoc';

const styles = require('./Historical-styles.css');

const Historical = ({ className }) => {
  const [qDoc, setQDoc] = useState(null);
  const [qObj, setQObj] = useState(null);
  const [editions, setEditions] = useState(null);
  const handleEditionClick = useCallback((event) => {
    const qElemNo = Number(event.target.dataset.qElemNo);
    qObj.selectListObjectValues('/qListObjectDef', [qElemNo], true);
  });
  useEffect(() => {
    (async () => {
      try {
        const _qDoc = await qDocPromise;
        setQDoc(_qDoc);
        const _qObj = await _qDoc.createSessionObject({
          qInfo: { qType: 'data' },
          qListObjectDef: {
            qDef: {
              qFieldDefs: ['=If(n_MatchStatusCode > 4 AND NOT isNull(n_MatchID), c_Edition)'],
            },
          },
        });
        setQObj(_qObj);
        _qObj.on('changed', async () => {
          setEditions(await _qObj.getListObjectData('/qListObjectDef', [{
            qTop: 0, qLeft: 0, qWidth: 1, qHeight: 50,
          }]));
        });
        setEditions(await _qObj.getListObjectData('/qListObjectDef', [{
          qTop: 0, qLeft: 0, qWidth: 1, qHeight: 50,
        }]));
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    })();
  }, []);
  useEffect(() => () => {
    if (qDoc) qDoc.clearAll();
    if (qObj) qDoc.destroySessionObject(qObj.id);
  }, [qDoc, qObj]);

  return (
    <div className={styles.historical}>
      <Header />
      <Nav />
      <KPIs />
      <div className={classnames(styles.historical, className)}>
        <div className={styles.historicalcontent}>
          <div className={styles.editions}>
            <div className={styles.editionsHeader}>ALL TOURNAMENTS</div>
            <div className={styles.editionsItems}>
              {editions && [...editions[0].qMatrix].sort((a, b) => Number(a[0].qText) - Number(b[0].qText)).map((edition) => (
                <div
                  key={edition[0].qElemNumber}
                  className={classnames(styles.editionsItem, edition[0].qState === 'S' && styles.active)}
                  data-q-elem-no={edition[0].qElemNumber}
                  onClick={handleEditionClick}
                >
                  {edition[0].qText}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.charts}>
            <div className={styles.chartGroup}>
              <div className={styles.chart3}>
                <div className={styles.chartMainTitle}>TEAMS RANKING</div>
                <div className={styles.chartDescription}>
                  {'The teams are ranked top to bottom based on the previous tournamnet’s order of finish. Each dot represents a tournament year. With three tournament wins, New Zealand ranks at the top of the list. Australia and South Africa have both won the tournament twice, while England has won it once. Of all the teams that participated in the previous eight tournaments, only five different teams have made it to the final. Japan, the 2019 host country, is looking to advance out of the Pool play for the first time. Select a year(s) to see the order of finish for each tournament.'}
                </div>

                <div className={styles.chart}>
                  <QdtComponent
                    type="QdtViz"
                    props={{
                      id: 'SgyPP', height: '400px', options: { showTitles: false }, noSelections: true,
                    }}
                  />
                </div>
              </div>
              <div className={styles.chart1}>
                <div className={styles.chartMainTitle}>TOURNAMENT MEDALS</div>
                <div className={styles.chartDescription}>
                  {''}
                </div>
                <div className={styles.chart}>
                  <QdtComponent
                    type="QdtViz"
                    props={{
                      id: 'TJTXz', height: '400px', options: { showTitles: false }, noSelections: true,
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.chart}>
              <div className={styles.chartTitle}>ALL ACTIONS</div>
              <div className={styles.chartDescription}>
                {'Discover at which minute of the game each offensive action happens over the history of the tournament, each bar represents one minute, and the colors represent each one of the offensive actions. The minicharts below show the shape of each individual action across the duration of the game. Number of tries and conversions rise by the end of the game, while penalties occur more often during the first half.'}
              </div>
              <QdtComponent
                type="QdtViz"
                props={{
                  id: 'tvbcaD', height: '500px', options: { showTitles: false }, noSelections: true,
                }}
              />
            </div>
            <div className={styles.chartGroup}>
              <div className={styles.chart}>
                <div className={styles.chartTitle}>TRIES</div>
                <QdtComponent
                  type="QdtViz"
                  props={{
                    id: 'APJJh', height: '100px', options: { showTitles: false }, noSelections: true,
                  }}
                />
              </div>
              <div className={styles.chart}>
                <div className={styles.chartTitle}>CONVERSIONS</div>
                <QdtComponent
                  type="QdtViz"
                  props={{
                    id: 'JzQVpQ', height: '100px', options: { showTitles: false }, noSelections: true,
                  }}
                />
              </div>
              <div className={styles.chart}>
                <div className={styles.chartTitle}>PENALTIES</div>
                <QdtComponent
                  type="QdtViz"
                  props={{
                    id: 'KJSw', height: '100px', options: { showTitles: false }, noSelections: true,
                  }}
                />
              </div>
              <div className={styles.chart}>
                <div className={styles.chartTitle}>DROP GOALS</div>
                <QdtComponent
                  type="QdtViz"
                  props={{
                    id: 'gUFxmYS', height: '100px', options: { showTitles: false }, noSelections: true,
                  }}
                />
              </div>
            </div>
            <div className={styles.chart}>
              <div className={styles.chartTitle}>TEAM STATS</div>
              <div className={styles.chartDescription}>
                {'Which team has won the most games? Which team scored the most points? Which team committed the most penalties? Find the answers to these questions and others. Use the filter at the top of the page to view the stats for a single tournament or multiple tournaments. Sort the table by clicking on the column header.'}
              </div>
              <QdtComponent
                type="QdtViz"
                props={{
                  id: 'BptJvF', height: '500px', options: { showTitles: false }, noSelections: true,
                }}
              />
            </div>
            <div className={styles.chart}>
              <div className={styles.chartTitle}>PLAYER STATS</div>
              <div className={styles.chartDescription}>
                {'Which player has participated in the most games? Who was the tallest player to participate in the tournament? Which players have received a red card? Find the answers to these questions and others. Use the filter at the top of the page to view the stats for a single tournament or multiple tournaments. Sort the table by clicking on the column header.'}
              </div>
              <QdtComponent
                type="QdtViz"
                props={{
                  id: 'eEvsNS', height: '500px', options: { showTitles: false }, noSelections: true,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

Historical.propTypes = {
  className: PropTypes.string,
};
Historical.defaultProps = {
  className: null,
};

export default Historical;
